function normalizeText(value, fieldName) {
  if (typeof value !== "string" || !value.trim()) {
    throw new Error(`Invalid assistant ${fieldName}`);
  }

  return value.trim().toLowerCase();
}

function cleanObject(value) {
  if (Array.isArray(value)) {
    return value
      .map(cleanObject)
      .filter((item) => item !== undefined && item !== null && item !== "");
  }

  if (value && typeof value === "object") {
    const next = Object.entries(value).reduce((acc, [key, innerValue]) => {
      const cleaned = cleanObject(innerValue);

      if (
        cleaned !== undefined &&
        cleaned !== null &&
        cleaned !== "" &&
        !(typeof cleaned === "object" && !Array.isArray(cleaned) && !Object.keys(cleaned).length) &&
        !(Array.isArray(cleaned) && !cleaned.length)
      ) {
        acc[key] = cleaned;
      }

      return acc;
    }, {});

    return Object.keys(next).length ? next : undefined;
  }

  return value;
}

export function buildDocumentationKey({ service, module, view }) {
  const normalizedService = normalizeText(service, "service");
  const normalizedModule = normalizeText(module, "module");
  const normalizedView = normalizeText(view, "view");

  return `${normalizedService}:${normalizedModule}:${normalizedView}`;
}

export function buildAssistantViewContext({
  service,
  module,
  view,
  entities = {},
  filters = {},
  uiState = {},
}) {
  const normalizedService = normalizeText(service, "service");
  const normalizedModule = normalizeText(module, "module");
  const normalizedView = normalizeText(view, "view");

  return cleanObject({
    service: normalizedService,
    module: normalizedModule,
    view: normalizedView,
    documentationKey: buildDocumentationKey({
      service: normalizedService,
      module: normalizedModule,
      view: normalizedView,
    }),
    entities,
    filters,
    uiState,
  });
}
